import * as React from 'react';
import { Set, is } from 'immutable';
import cx from 'classnames';
import elements from 'components/elements';

import { removeButton } from '../component';
import { isMandatory } from '../helpers';
import { createCelClassName } from './helpers';

import { VirtualTableCell, VirtualTableRow } from 'components/Tables/layout/JEVirtualLinesTable/StyledComponents';

function Cell({ r, c, getItem, ...rest }) {
  return (
    <VirtualTableCell
      as="div"
      key={c}
      className={cx('je-v-table-cell', createCelClassName(c), {
        'je-v-table-cell-mandatory': isMandatory(rest.cellEntry),
        'je-v-table-cell-active': rest.isActiveCell,
      })}
    >
      {getItem(r, c)}
    </VirtualTableCell>
  );
}

export class Row extends React.Component {
  static defaultProps = {
    lineItems: new Set(),
  };

  shouldComponentUpdate(nextProps) {
    const { lineItems, selectedRows, meta, active, rowEntries } = this.props;
    if (!is(selectedRows, nextProps.selectedRows)) return true;
    if (!is(lineItems, nextProps.lineItems)) return true;
    if (meta[0].length !== nextProps.meta[0].length) return true;
    if (active !== nextProps.active) return true;
    if (is(rowEntries, nextProps.rowEntries)) return true;
    return true;
  }

  get isRemoveDisable() {
    const { lineItems, rowEntries, reconcileColumn, r } = this.props;
    const status = rowEntries.getIn([reconcileColumn + r, 'cellSet', 'value']);
    if (!lineItems.has(r)) return true;
    if (status === 'Ignored') return true;
    if (status === 'NoBankAccount') return true;
    if (status === 'Reconciled') return true;
    return false;
  }

  render() {
    const { style, meta, r, active, getItem, selectedRows, reconcileColumn, rowEntries, removeHandler } = this.props;

    const removeButtonRender = removeButton({
      removeHandler,
    });

    return (
      <VirtualTableRow
        as="div"
        className={cx({ 'je-v-table-row-is-active': active ? active[1] === r : false })}
        style={style}
        data-element={elements.je.virtualGrid.row}
      >
        <div
          className={cx('je-v-table-cell je-v-table-cell-remove', {
            'je-v-table-cell-remove-disabled': this.isRemoveDisable,
          })}
        >
          {this.isRemoveDisable ? null : removeButtonRender(this.props.r)}
        </div>
        {meta[0].map((c) => (
          <Cell
            key={c}
            c={c}
            r={r}
            isActiveCell={active ? active[0] === c && active[1] === r : false}
            getItem={getItem}
            selectedRows={selectedRows}
            reconcileColumn={reconcileColumn}
            cellEntry={rowEntries.get(c + r)}
          />
        ))}
      </VirtualTableRow>
    );
  }
}

function VirtualRow({ index, style, data: { data, ...rest } }) {
  const row = rest.meta[1][index];
  const rowEntries = data.filter((f) => f._row === row);
  return <Row r={row} style={style} rowEntries={rowEntries} {...rest} />;
}

export default VirtualRow;
